export enum CAP_TABLE_VIEW_TYPE {
	VIEW_1 = 'VIEW_1', // default
	VIEW_2 = 'VIEW_2', // reverse columns
	VIEW_3 = 'VIEW_3', // reverse columns + rows
	VIEW_4 = 'VIEW_4', // reverse rows
}

export const CAP_TABLE_VIEW_OPTIONS = [
	{ value: CAP_TABLE_VIEW_TYPE.VIEW_1, label: 'Table View 1' },
	{ value: CAP_TABLE_VIEW_TYPE.VIEW_2, label: 'Table View 2' },
	{ value: CAP_TABLE_VIEW_TYPE.VIEW_3, label: 'Table View 3' },
	{ value: CAP_TABLE_VIEW_TYPE.VIEW_4, label: 'Table View 4' },
];

export enum CAP_TABLE_VALUE_DISPLAY_MODE {
	ABSOLUTE = 'absolute',
	PERCENTAGE = 'percentage',
}

export enum CAP_TABLE_VALUES_HELD_TYPE {
	VOTES = 'votes',
	SECURITIES = 'securities', //shares units
}

export enum CAP_TABLE_EXPAND_ROWS_MODE {
	COLLAPSE_ALL = 'COLLAPSE_ALL',
	EXPAND_ENTITIES = 'EXPAND_ENTITIES', // only entities rows expanded
	EXPAND_ALL = 'EXPAND_ALL', // default
}

export const CAP_TABLE_EXPAND_ROWS_MODE_OPTIONS = [
	{ value: CAP_TABLE_EXPAND_ROWS_MODE.COLLAPSE_ALL, label: '' },
	{ value: CAP_TABLE_EXPAND_ROWS_MODE.EXPAND_ENTITIES, label: '' },
	{ value: CAP_TABLE_EXPAND_ROWS_MODE.EXPAND_ALL, label: '' },
];
